/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import bool from '../view/control/BooleanControlView';
import singleValueText from '../view/control/SingleValueTextControlView';
import singleValueNumber from '../view/control/SingleValueNumberControlView';
import singleValueDate from '../view/control/SingleValueDateControlView';
import singleValueDatetime from '../view/control/SingleValueDatetimeControlView';
import singleValueTime from '../view/control/SingleValueTimeControlView';
import singleSelect from '../view/control/SingleSelectControlView';
import singleSelectRadio from '../view/control/SingleSelectRadioControlView';
import multiSelect from '../view/control/MultiSelectControlView';
import multiSelectCheckbox from '../view/control/MultiSelectCheckboxControlView';

export default {
    'bool': bool,
    'singleValueText': singleValueText,
    'singleValueNumber': singleValueNumber,
    'singleValueDate': singleValueDate,
    'singleValueDatetime': singleValueDatetime,
    'singleValueTime': singleValueTime,
    'singleSelect': singleSelect,
    'singleSelectRadio': singleSelectRadio,
    'multiSelect': multiSelect,
    'multiSelectCheckbox': multiSelectCheckbox
};